import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'timeAgo',
	standalone: true
})
export class TimeAgoPipe implements PipeTransform {

	transform(value: string | Date): string {
		if (!value) return '';

		const date = new Date(value);
		const now = new Date();
		const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

		const intervals: { [key: string]: number } = {
			year: 31536000,
			month: 2592000,
			week: 604800,
			day: 86400,
			hour: 3600,
			minute: 60,
			second: 1
		};

		for (const key in intervals) {
			const interval = Math.floor(seconds / intervals[key]);
			if (interval >= 1) {
				return interval === 1 ? `1 ${key} ago` : `${interval} ${key}s ago`;
			}
		}

		return 'just now';
	}
}